import GalleryPieceRecords from "./GalleryPieceRecords";

export default GalleryPieceRecords;
